export default __webpack_public_path__ + "static/agardner-4587237cf199c36a4bfcf19069229deb.png";